import React from 'react';
import Link from 'next/link';
import Typography from '@/components/atoms/typography';
import { ClockIcon, PlayCircleIcon } from '@heroicons/react/24/solid';
import Image from '@/components/atoms/Image';


// Define the type for the props
interface Video {
  idVideo: string;
  idItem: string;
  videoThumbnail: string;
  videoName: string;
  videoDuration: string;
  videoType: string;
  dateUpdated: string;
  category: string;
}

interface ListProps {
  data: {
    videoList: Video[];
  };
}

const List = ({ data }: ListProps) => {

  return (
    <div className="mx-auto lg:py-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {data.videoList.map((video) => (
          <Link
            href={`/video-list/${video.idVideo}`}
            key={`${video.idVideo}-${video.idItem}`}
            className="block group relative bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300"
          >
            <div className="relative aspect-video bg-gray-100">
              <Image
                priority
                src={video.videoThumbnail}
                alt={video.videoName ?? ''}
                style={{ objectPosition: 'center' }}
                className="w-full h-full !relative rounded-sm group-hover:opacity-75"
                fill
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              />
              {/* <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <PlayCircleIcon className="h-12 w-12 text-white" />
              </div> */}
              <div className="absolute top-2 right-2 bg-[#48C9B080] bg-opacity-70 text-white text-xs px-[18px] py-[10px] rounded flex items-center">
                {/* <ClockIcon className="h-3 w-3 mr-1" /> */}
                <span className="text-16 font-bold">
                  {video.videoDuration.trim()} {video.videoDuration.trim() === '1' ? 'min' : 'mins'}
                </span>
              </div>
            </div>
            <div className="p-2">
              <h3 className="font-medium text-gray-900 mb-2 line-clamp-2">
                {video.videoName}
              </h3>
              <div className="flex justify-between items-start">
                <span className="text-12 font-medium text-gray-700 bg-[#ececec] px-2 py-1 rounded">
                  {video.videoType}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default List;